/**
 * 

 * Generated by orval 🍺
 * Do not edit manually.
 * OpenAPI spec version: 0.0.0 (v7)
 */

export type PetCompatibilityQuestionEnum =
  (typeof PetCompatibilityQuestionEnum)[keyof typeof PetCompatibilityQuestionEnum];

export const PetCompatibilityQuestionEnum = {
  dogs: 'dogs',
  cats: 'cats',
  kids: 'kids',
} as const;
